// extracted by mini-css-extract-plugin
module.exports = {"comp5":"Sect3_Component5_comp5__X9Zc0","left":"Sect3_Component5_left__10UVp","right":"Sect3_Component5_right__18L2g"};